module.exports = __webpack_public_path__ + "static/Ibadat-bc3dee63064622d569493eb9c8d15414.png";